export const PRODUCTS = [
  {
    slug: "rubber-rolls",
    index: "01",
    name: "Rubber Rolls",
    short: "Custom-compounded rubber covered rolls for demanding web, sheet and process lines.",
    image: "/images/rubber_rolls.jpg",
    gallery: ["/images/rubber_rolls.jpg", "/images/technical_services.jpg"],
    intro:
      "Rubber covered rolls are the core of the Vikas Rolls programme. Every cover is compounded in-house around the operating speed, load, pressure, temperature, friction and process medium of your line — and around the characteristics of the product it will touch.",
    characteristics: [
      "In-house compound development matched to the application",
      "Covers engineered for defined hardness, resilience and grip",
      "Precision ground finishes for consistent nip behaviour",
      "New manufacture and economical re-covering of used rolls",
    ],
    applications: [
      "Nip, squeeze and pressure applications",
      "Guide, tension and carrier positions",
      "Coating, laminating and impression duties",
      "Wringer, applicator and pick-up positions",
    ],
    industries: ["Steel", "Paper", "Packaging", "Textile", "Printing", "Leather", "Plywood"],
    customization: ["Elastomer selection", "Cover hardness", "Surface finish & grooving", "Core design", "Roll dimensions"],
    relatedServices: ["rubber-covering", "regrinding", "balancing", "repairing"],
    specNote: "Dimensions, hardness ranges and tolerances are engineered to application requirements.",
  },
  {
    slug: "polyurethane-rolls",
    index: "02",
    name: "Polyurethane Rolls",
    short: "Ribbon-build polyurethane covers with exceptional abrasion and tear resistance.",
    image: "/images/polyurethane_roll.jpg",
    gallery: ["/images/polyurethane_roll.jpg", "/images/poly_urethane.jpg", "/images/pu_covering.jpg"],
    intro:
      "Vikas Rolls applies polyurethane covers using the Ribbon Build System. The result is a versatile family of PU rolls that outperform both rubber and conventionally cast polyurethane in abrasive, high-load and solvent-exposed service.",
    characteristics: [
      "Ribbon Build System application for a dense, void-free cover",
      "Excellent abrasion and tear resistance",
      "High compressive strength under sustained load",
      "Strong compatibility with solvents and acids",
      "Reduced downtime for roll changing",
    ],
    applications: [
      "High-wear feed and pull positions",
      "Load-bearing squeeze and press duties",
      "Chemically exposed process positions",
      "High-cycle converting and handling lines",
    ],
    industries: ["Steel", "Paper", "Packaging", "Plywood", "Glass", "Conveyor Systems"],
    customization: ["PU formulation", "Cover hardness", "Cover thickness", "Surface profile", "Core design"],
    relatedServices: ["pu-covering", "core-manufacturing", "regrinding", "balancing"],
    specNote: "Formulation, hardness and cover build are specified to application requirements.",
  },
  {
    slug: "steel-rolls",
    index: "03",
    name: "Steel Rolls",
    short: "Precision-machined steel rolls and fabricated cores, from small components to large industrial rolls.",
    image: "/images/steel_rolls_new.jpg",
    gallery: ["/images/steel_rolls_new.jpg", "/images/steel_rolls.jpg", "/images/core_manufacturing.jpg"],
    intro:
      "Vikas Rolls manufactures steel rolls and roll cores for OEMs and end users — controlling material selection, machining, welding, balancing and finishing under one roof. Rolls range from small precision components to large industrial rolls.",
    characteristics: [
      "Complete in-house core manufacturing",
      "Certified welding across diverse alloys",
      "Machined and finished to drawing",
      "Dynamically balanced for smooth high-speed running",
    ],
    applications: [
      "Bare steel process rolls",
      "Cores for rubber and polyurethane covering",
      "Replacement rolls built to sample or drawing",
      "Fabricated drums and pulleys",
    ],
    industries: ["Steel", "Paper", "Glass", "Conveyor Systems", "Packaging"],
    customization: ["Material grade", "Journal design", "Wall thickness", "Surface treatment", "Dimensions to drawing"],
    relatedServices: ["core-manufacturing", "repairing", "balancing", "hard-chrome-plating"],
    specNote: "Materials, dimensions and tolerances are manufactured to customer drawings and application requirements.",
  },
  {
    slug: "hard-chromed-rolls",
    index: "04",
    name: "Hard Chromed Rolls",
    short: "Chromium-plated rolls that resist abrasion, friction, corrosion, heat and vibration.",
    image: "/images/hard_chromed.jpg",
    gallery: ["/images/hard_chromed.jpg", "/images/hard_chrome_plating.jpg"],
    intro:
      "Abrasion, friction, corrosion, heat and vibration are the most frequent causes of steel roll wear. Hard chrome plating interposes a super-hard, anti-friction, rust-resistant layer between exposed and mating surfaces — extending service life and protecting roll geometry.",
    characteristics: [
      "Super-hard, low-friction working surface",
      "Strong resistance to corrosion and rust",
      "Protects base geometry in abrasive service",
      "Suitable for new rolls and refurbishment",
    ],
    applications: [
      "Abrasive web and sheet contact positions",
      "Corrosive or wet process environments",
      "High-friction guide and drive duties",
      "Restoration of worn roll surfaces",
    ],
    industries: ["Steel", "Paper", "Packaging", "Printing", "Textile"],
    customization: ["Plating thickness", "Surface finish", "Base roll manufacture", "Refurbishment scope"],
    relatedServices: ["hard-chrome-plating", "regrinding", "repairing"],
    specNote: "Plating thickness and finish are specified to application requirements.",
  },
  {
    slug: "induction-hardened-rolls",
    index: "05",
    name: "Induction Hardened Rolls",
    short: "Uniformly hardened barrel surfaces with cool necks and cores — minimal internal stress.",
    image: "/images/induction_hardened.jpg",
    gallery: ["/images/induction_hardened.jpg", "/images/induction.jpg"],
    intro:
      "In induction hardening, the roll barrel passes through a series of electrical coils and directly into the quench. Fast heat penetration and immediate quenching produce a defined layer of uniform hardness, while the necks and core remain cool — minimising internal stress and producing highly favourable metallurgical properties.",
    characteristics: [
      "Defined, uniform hardened surface layer",
      "Necks and core remain unaffected by heat",
      "Minimised internal stresses",
      "Favourable metallurgical structure",
    ],
    applications: [
      "Wear-critical barrel surfaces",
      "High-load rolling and processing duties",
      "Rolls requiring a hard case with a tough core",
    ],
    industries: ["Steel", "Paper", "Glass", "Conveyor Systems"],
    customization: ["Hardening depth", "Hardness level", "Base roll manufacture", "Finishing specification"],
    relatedServices: ["induction-hardening", "core-manufacturing", "regrinding"],
    specNote: "Case depth and hardness are engineered to application requirements.",
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
